(function () {

  var linkFunction = function ($scope, element, attrs) {
    // console.log("Payment Method Link Func: ", $scope, element, attrs);
  }

  var controllerFunction = function ($scope, $rootScope, $state, loggerService, loggerServiceHelper, userSession, webAnalytics, $rootScope, $uibModal, modifyFormOfPaymentService, RFOP, EM, AccountDataSvc, loggerServiceHelper, loggerService) {
    $scope.content = wcmContent;
    $scope.isMobile = cvsUtility.isMobile();

    angular.element("#mydiv").show();
    angular.element("#specialtySpinner").show();
    angular.element("#loader").show();

    var log = loggerService(loggerServiceHelper.setCategory(CVSLOGHELPER.CATEGORY.SelectAPayment));

    angular.forEach($scope.session.accountData.paymentMethods, function (item, index) {
      angular.element("#mydiv").hide();
      angular.element("#specialtySpinner").hide();
      angular.element("#loader").hide();
      if (item.activeFlag === 'ACTIVE' || item.activeFlag === 'INACTIVE') { //SPEC-1972 - INACTIVE
        if ($scope.$parent.editMopData) {
          if (item.paymentMethodId === $scope.$parent.editMopData.paymentMethodId) {
            $scope.session.accountData.paymentMethods.splice(index, 1);
          }
          //$scope.session.paymentMethod = item.paymentMethodId;
        } else {
          if (userSession.persit["__scopePersist_session.selectedPaymentMethod"] && userSession.persit["__scopePersist_session.selectedPaymentMethod"] !== null) {
            $scope.session.selectedPaymentMethod = userSession.persit["__scopePersist_session.selectedPaymentMethod"];
          } else {

            if ($scope.session.accountData.paymentMethods.length > 0) {
              for (var index = 0; index < $scope.session.accountData.paymentMethods.length; index++) {
                if ($scope.session.accountData.paymentMethods[index].expiryDate != null) {
                  $scope.session.accountData.paymentMethods[index].expiredIndicator = moment("01-" + $scope.session.accountData.paymentMethods[index].expiryDate.month + "-" + $scope.session.accountData.paymentMethods[index].expiryDate.year, "DD-MM-YYYY").isBefore(moment(), 'year', 'month');
                }
                else {
                  $scope.session.accountData.paymentMethods[index].expiredIndicator = false;
                }
              }
            }
            $scope.session.paymentMethod = item.paymentMethodId;

          }
        }
      }
    });

    if($scope.session && $scope.session.accountData && $scope.session.accountData.paymentMethods && $scope.session.accountData.paymentMethods.length == 0){
      setTimeout(function () {
        angular.element("#mydiv").hide();
        angular.element("#specialtySpinner").hide();
        angular.element("#loader").hide();
      }, 200);
    }

    $scope.selectMehodOfPayment = $scope.$parent.editMopData ? false : true;

    $scope.displayLength = 3;
    $scope.showMore = function () {
      $scope.displayLength = $scope.session.accountData.paymentMethods.length;
    }

    $scope.showLess = function () {
      $scope.displayLength = 3;
    }

    $scope.checkExpiration = function (expiration) {
      if (!expiration) return false;
      return moment(expiration, "MM-YYYY").isBefore(moment.now());
    }
    $scope.doesExpireSoon = function (expiration) {
      if (!expiration) return false;
      return moment("01-" + expiration.month + "-" + expiration.year, "DD-MM-YYYY").isBefore(moment().add(1, 'month'));
    }
    $scope.checkExpirationIndicator = function (expiration) {
      if (!expiration) return false;
      const cardDate = moment("01-" + expiration.month + "-" + expiration.year, "DD-MM-YYYY");
      return cardDate.isBefore(moment(), 'month') && cardDate.isSameOrBefore(moment(), 'year');
    }

    $scope.editMop = function (mop) {

      if (mop.payment.method === 'CCARD') { //SPEC-2351
        $rootScope.expiryFlag = moment("01-" + mop.expiryDate.month + "-" + mop.expiryDate.year, "DD-MM-YYYY").isBefore(moment().add(1, 'month'));
        if ($rootScope.expiryFlag) {
          //SPEC-2018: item 3 - 06/2019
          webAnalytics.webTrendsUtag("LINK", {
            'link_name': 'Custom:edit expiring card link'
          });
        }
      }
      $scope.session.paymentMethod = mop.paymentMethodId;
      localStorage.clear();
      Object.keys(userSession.persit).forEach(function (key) { delete userSession.persit[key]; });
      localStorage.setItem("transactionMode", "EDIT");
      var dest = mop.payment.method == "CHECK" ? "edit-bank-account-info" : "edit-payment-card-info";
      //$state.go(dest, { 'mopid': mop.paymentMethodId, 'editMode': false });
      $state.go(dest, { 'mopid': mop.paymentMethodId, 'editMode': true, 'expired': mop.expiredIndicator });
    };

    $scope.expireedit = function () {
      setTimeout(function () {
        document.getElementById('editmop').focus();
        document.getElementById("editmop").scrollIntoView({ behavior: 'smooth' });
      }, 100);
    }
    $("#edit_mop").keyup(function (event) {
      if (event.keyCode === 13) {
        $("#edit_mop").click();
      }
    });

    $scope.getCardMOPType = function (mopType) {
      var cardType = "Bank Account";
      switch (mopType) {
        case 'VISA':
          cardType = "VISA";
          break;
        case 'DISCOVER':
          cardType = "Discover";
          break;
        case 'MASTERCARD':
          cardType = "Mastercard";
          break;
        case 'AMERICAN EXPRESS':
          cardType = "American Express";
          break;
        case 'DINERS CLUB':
          cardType = "Diners Club";
          break;
        default:
          cardType = "Bank account";
      }
      return cardType;
    }
   
    /**
     * [US319627] UI: Modal dialog for Remove Method Payment
     */

    $scope.removeMop = function (mop) {

      var modalInstance = $uibModal.open({
        ariaLabelledBy: 'name',
        ariaDescribedBy: 'desc',
        templateUrl: '../payments/app/components/modals/removeMop-modal.template.html',
        size: 'md',
        backdrop: 'static',
        keyboard: 'true',
        windowClass: 'paymentsContainer remove-methodOfPayment-popup',
        controller: function ($uibModalInstance, $scope, webAnalytics) {

          if (log && log.entry) {
            log.entry(loggerServiceHelper.setFlow(CVSLOGHELPER.FLOW.RemoveAPayment) + loggerServiceHelper.setAction(CVSLOGHELPER.ACTION.PAGE_LOAD) +
              loggerServiceHelper.setStep(CVSLOGHELPER.STEP.START) + loggerServiceHelper.setDescription("Remove payment modal Page is loading "));
          }
          $scope.name = "Confirm removal";
          $scope.body = "if you don't want this XXXXXX displayed in your list of payment options, select Remove";
          $scope.fullaccountNumber = mop.accountNumber;
          $scope.choosencardtype = mop.payment.method;
          $scope.paymentObj = mop.payment;
          var lastFour = $scope.fullaccountNumber.substring($scope.fullaccountNumber.length - 4);
          var removeMopPaymentType = $scope.getCardMOPType(mop.payment.mopType);

          /* 
           * Add tag to remove MOP modal on load 
           * show on select a payment: are you sure modal
           */
          var utagObj = {};
          var pageError;
          utagObj.page_name = 'srx: select a payment: are you sure modal';
          utagObj.adobe_page_name = 'cvssp' + '|' + cvsUtility.getPlatform() + '|' + utagObj.page_name;
          utagObj.page_category = 'payments';
          utagObj.page_error = pageError;
          webAnalytics.webTrendsUtag("OBJ", utagObj, undefined);

          var modal = {
            removemopsuccessmessage: {
              title: "<cardtype> ending in <lastfour> has been removed successfully.",
              mopremovalSuccess: false
            },
            inflightpaymentmessage: {
              title: "This <cardtype> ending in <lastfour> is associated with a payment that's in progress, so it can't be removed at this time. Please allow 48 hours for your payment to process and try again.",
              mopinflightPaymentfailed: false,
            },
            mopautoppaymentsmessage: {
              title: "To remove this <cardtype> ending in <lastfour> you'll need to select a new automatic payment method. This can be done by navigating to Balance and Payments.",
              moputoppaymentsFailed: false,
            },
            retrievepaymentsmessage: {
              title: "<cardtype> ending in <lastfour> was successfully removed, but your list of payment methods may take some time to update. You can either use another method of payment and continue, or return to the Account balance and payments page.",
              retrievePaymentFailed: false,
            }

          }

          if (mop) {
            modal.removemopsuccessmessage.title = modal.removemopsuccessmessage.title.replace("<lastfour>", lastFour);
            modal.removemopsuccessmessage.title = modal.removemopsuccessmessage.title.replace("<cardtype>", removeMopPaymentType);
            modal.inflightpaymentmessage.title = modal.inflightpaymentmessage.title.replace("<lastfour>", lastFour);
            modal.inflightpaymentmessage.title = modal.inflightpaymentmessage.title.replace("<cardtype>", removeMopPaymentType);
            modal.mopautoppaymentsmessage.title = modal.mopautoppaymentsmessage.title.replace("<lastfour>", lastFour);
            modal.mopautoppaymentsmessage.title = modal.mopautoppaymentsmessage.title.replace("<cardtype>", removeMopPaymentType);
            modal.retrievepaymentsmessage.title = modal.retrievepaymentsmessage.title.replace("<lastfour>", lastFour);
            modal.retrievepaymentsmessage.title = modal.retrievepaymentsmessage.title.replace("<cardtype>", removeMopPaymentType);
          } else {
            modal.removemopsuccessmessage.title = modal.removemopsuccessmessage.title.replace("<last>", "");
            modal.removemopsuccessmessage.title = modal.removemopsuccessmessage.title.replace("<cardtype>", "");
            modal.inflightpaymentmessage.title = modal.inflightpaymentmessage.title.replace("<lastfour>", "");
            modal.inflightpaymentmessage.title = modal.inflightpaymentmessage.title.replace("<cardtype>", "");
            modal.mopautoppaymentsmessage.title = modal.mopautoppaymentsmessage.title.replace("<lastfour>", "");
            modal.mopautoppaymentsmessage.title = modal.mopautoppaymentsmessage.title.replace("<cardtype>", "");
            modal.retrievepaymentsmessage.title = modal.retrievepaymentsmessage.title.replace("<lastfour>", "");
            modal.retrievepaymentsmessage.title = modal.retrievepaymentsmessage.title.replace("<cardtype>", "");
          }

          $rootScope.$emit("mopsuccessfullyremoved", modal.removemopsuccessmessage);
          $scope.$emit("mopinflightPaymentfailed", modal.inflightpaymentmessage);
          $scope.$emit("mopautoppaymentsFailed", modal.mopautoppaymentsmessage);
          $rootScope.$emit("retrievePaymentsFailed", modal.retrievepaymentsmessage);


          $scope.remove = function () {
            // console.log(modifyFormOfPaymentService.modifyFormOfPayment);
            var formData = {
              paymentMethodId: mop.paymentMethodId,
              cardholder: {
                firstName: mop.cardholder.firstName,
                lastName: mop.cardholder.lastName
              },
              billingAddress: {
                addressLine1: mop.billingAddress.addressLine1,
                addressLine2: mop.billingAddress.addressLine2,
                city: mop.billingAddress.city,
                state: mop.billingAddress.state,
                zipCode: mop.billingAddress.zipCode,
                zipCodeExt: mop.billingAddress.zipCodeExt
              },
              expiryDate: (mop.expiryDate == undefined) ? undefined : mop.expiryDate,
              transactionMode: 'REMOVE',
              mopForFuture: 'false',
              createdBy: 'DIGITAL WEB',
              relationshipToCardHolder: mop.relationshipToCardHolder
            }

            modifyFormOfPaymentService.modifyFormOfPayment(formData, function (response) {
              angular.element("#mydiv").show();
              angular.element("#specialtySpinner").show();
              angular.element("#loader").show();
              if (loggerServiceHelper) {
                log.info(loggerServiceHelper.setFlow(CVSLOGHELPER.FLOW.RemoveAPayment) + loggerServiceHelper.setAction(CVSLOGHELPER.ACTION.BUTTON_CLICK) + 
                loggerServiceHelper.setStep(CVSLOGHELPER.STEP.ServiceCallDone) + loggerServiceHelper.setServiceName("modifyFormOfPaymentService"));
              }
              if (response.SERVER_ERROR) {
                /**logging**/
                if (loggerServiceHelper) {
                  log.error(loggerServiceHelper.setFlow(CVSLOGHELPER.FLOW.RemoveAPayment) + loggerServiceHelper.setAction(CVSLOGHELPER.ACTION.BUTTON_CLICK) + loggerServiceHelper.setStep(CVSLOGHELPER.STEP.END) + 
                  loggerServiceHelper.setServiceName("modifyFormOfPaymentService") + loggerServiceHelper.setStatus("ERROR") + loggerServiceHelper.setDescription(" ERROR " + JSON.stringify(response)));
                }
                pageError = cvsUtility.getPageError(response, 'Fatal', 'modifyFormOfPaymentService');
                EM.setRefId(response.SERVER_ERROR ? response.SERVER_STATUS : response.apiResponse.showError.refId);
                AccountDataSvc.setReferenceId(response.SERVER_ERROR ? response.SERVER_STATUS : response.apiResponse.showError.refId);
                $scope.updateAccountError = true;
                $rootScope.$emit("updateAccountError", $scope.updateAccountError);

                angular.element("#mydiv").hide();
                angular.element("#specialtySpinner").hide();
                angular.element("#loader").hide();

                $uibModalInstance.dismiss();
                var utagObj = {
                  page_error: pageError
                };
                webAnalytics.webTrendsUtag("VIEW", utagObj, undefined, undefined);
                return;
              }
              var header = response.getHeader();
              var statusCode = header.statusCode;

              if (response.getError() === '' && statusCode === "0000") {
                /* 
                 * Add tag to remove MOP modal 
                 * Fire on Modal: On click of remove (Success Scenario)
                 */
                webAnalytics.webTrendsUtag("LINK", {
                  link_name: 'custom: srx: select a payment: are you sure modal: remove link: success',
                  link_trackvars: 'events',
                  link_trackevents: 'event00'
                });

                //log for success mop
                if (loggerServiceHelper) {
                  log.info(loggerServiceHelper.setFlow(CVSLOGHELPER.FLOW.RemoveAPayment) + loggerServiceHelper.setAction(CVSLOGHELPER.ACTION.BUTTON_CLICK) + 
                  loggerServiceHelper.setStep(CVSLOGHELPER.STEP.END) + loggerServiceHelper.setServiceName("modifyFormOfPaymentService") + loggerServiceHelper.setStatus("SUCCESS") + 
                  loggerServiceHelper.setDescription(" SUCCESS " + JSON.stringify(response)));
                }

                
                $uibModalInstance.dismiss();

                // call retriveformofpayment service
                RFOP.retrieveFormOfPaymentdata(onGetPaymentSuccess);

              }
              else {
                switch (statusCode) {
                  case 'DBPL6029':
                  case 'SET_MOP_022': {
                    if (log.error && loggerServiceHelper) {
                      log.error(loggerServiceHelper.setFlow(CVSLOGHELPER.FLOW.RemoveAPayment) + loggerServiceHelper.setAction(CVSLOGHELPER.ACTION.BUTTON_CLICK) + loggerServiceHelper.setStep(CVSLOGHELPER.STEP.END) + loggerServiceHelper.setServiceName("modifyFormOfPaymentService") + loggerServiceHelper.setStatus("ERROR") + loggerServiceHelper.setDescription(" ERROR " + JSON.stringify(response)));
                    }
                    modal.inflightpaymentmessage.mopinflightPaymentfailed = true; // Flag to show inflight banner 
                    $scope.$emit("mopinflightPaymentfailed", modal.inflightpaymentmessage);
                    addRemoveMOPErrorTag(response);

                    setTimeout(function () {
                      document.getElementById("inflightErrorBlock").focus();
                      document.getElementById("inflightErrorBlock").scrollIntoView({ behavior: 'smooth' });
                    }, 300);

                    angular.element("#mydiv").hide();
                    angular.element("#specialtySpinner").hide();
                    angular.element("#loader").hide();

                    $uibModalInstance.dismiss();
                    break;
                  }
                  case 'DBPL6030':
                  case 'SET_MOP_023': {
                    if (log.error && loggerServiceHelper) {
                      log.error(loggerServiceHelper.setFlow(CVSLOGHELPER.FLOW.RemoveAPayment) + loggerServiceHelper.setAction(CVSLOGHELPER.ACTION.BUTTON_CLICK) + loggerServiceHelper.setStep(CVSLOGHELPER.STEP.END) + loggerServiceHelper.setServiceName("modifyFormOfPaymentService") + loggerServiceHelper.setStatus("ERROR") + loggerServiceHelper.setDescription(" ERROR " + JSON.stringify(response)));
                    }
                    modal.mopautoppaymentsmessage.moputoppaymentsFailed = true; // Flag to show autopayments failed banner 
                    $scope.$emit("mopautoppaymentsFailed", modal.mopautoppaymentsmessage);
                    addRemoveMOPErrorTag(response);

                    setTimeout(function () {
                      document.getElementById("autopaymentsErrorBlock").focus();
                      document.getElementById("autopaymentsErrorBlock").scrollIntoView({ behavior: 'smooth' });
                    }, 300);

                    angular.element("#mydiv").hide();
                    angular.element("#specialtySpinner").hide();
                    angular.element("#loader").hide();

                    $uibModalInstance.dismiss();
                    break;
                  }
                  default: {
                    if (log.error && loggerServiceHelper) {
                      log.error(loggerServiceHelper.setFlow(CVSLOGHELPER.FLOW.RemoveAPayment) + loggerServiceHelper.setAction(CVSLOGHELPER.ACTION.BUTTON_CLICK) + loggerServiceHelper.setStep(CVSLOGHELPER.STEP.END) + loggerServiceHelper.setServiceName("modifyFormOfPaymentService") + loggerServiceHelper.setStatus("ERROR") + loggerServiceHelper.setDescription(" ERROR " + JSON.stringify(response)));
                    }
                    AccountDataSvc.setReferenceId(response.apiResponse.showError.refId);
                    $scope.updateAccountError = true;
                    $rootScope.$emit("updateAccountError", $scope.updateAccountError);
                    addRemoveMOPErrorTag(response);

                    setTimeout(function () {
                      document.getElementById('systemerror').focus();
                      document.getElementById('systemerror').scrollIntoView({
                        behavior: 'smooth'
                      });
                    }, 100);
                    
                    angular.element("#mydiv").hide();
                    angular.element("#specialtySpinner").hide();
                    angular.element("#loader").hide();

                    $uibModalInstance.dismiss();
                    break;
                  }
                }
              }

            });

          }

          function addRemoveMOPErrorTag(response) {
            var pageError = cvsUtility.getPageError(response, 'Fatal', 'modifyFormOfPayment');
            webAnalytics.webTrendsUtag("LINK", {
              link_name: 'custom: srx: select a payment: are you sure modal: remove link: error',
              link_trackvars: 'events',
              link_trackevents: 'event00',
              page_error: pageError
            });
          }

          function onGetPaymentSuccess(response) {
            if (loggerServiceHelper) {
              log.info(loggerServiceHelper.setFlow(CVSLOGHELPER.FLOW.RetrievePayments) + loggerServiceHelper.setAction(CVSLOGHELPER.ACTION.BUTTON_CLICK) + 
              loggerServiceHelper.setStep(CVSLOGHELPER.STEP.ServiceCallDone) + loggerServiceHelper.setServiceName("retrieveFormOfPaymentService"));
            }
            if (response.getError() === '') {
             
              //log for success retrieveFormOfPayment
              if (loggerServiceHelper) {
                log.info(loggerServiceHelper.setFlow(CVSLOGHELPER.FLOW.RetrievePayments) + loggerServiceHelper.setAction(CVSLOGHELPER.ACTION.BUTTON_CLICK) + 
                loggerServiceHelper.setStep(CVSLOGHELPER.STEP.END) + loggerServiceHelper.setServiceName("retrieveFormOfPaymentService") + loggerServiceHelper.setStatus("SUCCESS") + 
                loggerServiceHelper.setDescription(" SUCCESS " + JSON.stringify(response)));
              }

              modal.removemopsuccessmessage.mopremovalSuccess = true; // Flag to show success banner 
              $rootScope.$emit("mopsuccessfullyremoved", modal.removemopsuccessmessage);
              setTimeout(function () {
                document.getElementById("successBlock").focus();
                document.getElementById("successBlock").scrollIntoView({ behavior: 'smooth' });
              }, 300);

              // update the list of payment methods
              AccountDataSvc.updateListMop(response.getPaymentInfos());

            }else {
              var showError = response.getError();
              var statusCode = showError.statusCode;
              AccountDataSvc.setRecentPaymentMethodId(mop.paymentMethodId);
              switch (statusCode) {
                case 'DBPL9999': {
                  if (log.error && loggerServiceHelper) {
                    log.error(loggerServiceHelper.setFlow(CVSLOGHELPER.FLOW.RetrievePayments) + loggerServiceHelper.setAction(CVSLOGHELPER.ACTION.BUTTON_CLICK) + 
                    loggerServiceHelper.setStep(CVSLOGHELPER.STEP.END) + loggerServiceHelper.setServiceName("retrieveFormOfPaymentService") + loggerServiceHelper.setStatus("ERROR") + loggerServiceHelper.setDescription(" ERROR " + JSON.stringify(response)));
                  }
                  var pageError = cvsUtility.getPageError(response, 'Fatal', 'retrieveFormOfPaymentService');
                  //EM.setRefId(response.SERVER_ERROR ? response.SERVER_STATUS : response.apiResponse.showError.refId);
                  AccountDataSvc.setReferenceId(response.apiResponse.showError.refId);
                  $scope.updateAccountError = true;
                  $rootScope.$emit("updateAccountError", $scope.updateAccountError);

                  setTimeout(function () {
                    document.getElementById('systemerror').focus();
                    document.getElementById('systemerror').scrollIntoView({
                      behavior: 'smooth'
                    });
                  }, 100);

                  break;
                }
                case '6006': {
                  if (log.error && loggerServiceHelper) {
                    log.error(loggerServiceHelper.setFlow(CVSLOGHELPER.FLOW.RetrievePayments) + loggerServiceHelper.setAction(CVSLOGHELPER.ACTION.BUTTON_CLICK) + 
                    loggerServiceHelper.setStep(CVSLOGHELPER.STEP.END) + loggerServiceHelper.setServiceName("retrieveFormOfPaymentService") + loggerServiceHelper.setStatus("ERROR") + loggerServiceHelper.setDescription(" ERROR " + JSON.stringify(response)));
                  }
                 // update the list of payment methods
                  AccountDataSvc.updateListMop([]);
                  AccountDataSvc.setRecentPaymentMethodId("");
                  break;
                }
                default: {
                  if (log.error && loggerServiceHelper) {
                    log.error(loggerServiceHelper.setFlow(CVSLOGHELPER.FLOW.RetrievePayments) + loggerServiceHelper.setAction(CVSLOGHELPER.ACTION.BUTTON_CLICK) + 
                    loggerServiceHelper.setStep(CVSLOGHELPER.STEP.END) + loggerServiceHelper.setServiceName("retrieveFormOfPaymentService") + loggerServiceHelper.setStatus("ERROR") + loggerServiceHelper.setDescription(" ERROR " + JSON.stringify(response)));
                  }
                  modal.retrievepaymentsmessage.retrievePaymentFailed = true;// Flag to show retrieve payments failed banner
                  $rootScope.$emit("retrievePaymentsFailed", modal.retrievepaymentsmessage);

                  setTimeout(function () {
                    document.getElementById('retrievePaymentsErrorBlock').focus();
                    document.getElementById('retrievePaymentsErrorBlock').scrollIntoView({
                      behavior: 'smooth'
                    });
                  }, 100);
                  break;
                }
              }
            }
          }

          $scope.cancel = function () {
            $uibModalInstance.dismiss();
          };

        },
        scope: $scope
      });

      cvsUtility.alignModalinPortal(modalInstance, 'remove-methodOfPayment-popup');
      $('body', window.parent.document).scrollTop(0);
    };

  }

  var directiveFunction = function () {
    return {
      restrict: 'E',
      templateUrl: '../payments/app/components/paymentMethods/paymentMethods.template.html',
      controller: controllerFunction,
      link: linkFunction
    }
  }

  controllerFunction.$inject = ["$scope", "$rootScope", "$state", "loggerService", "loggerServiceHelper", "userSession", "webAnalytics", "$rootScope", "$uibModal", "modifyFormOfPaymentService", "retrieveFormOfPaymentService", "errorModel", "accountDataService", 'loggerServiceHelper', 'loggerService'];
  angular.module('cvsApp').directive('paymentMethods', directiveFunction);


})();
